module.exports = __webpack_public_path__ + "static/media/right-arrow-solid-white.72ed0edc.svg";